import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import GNEModal from 'components/shared/modal/Modal';
import LinkButton from 'components/shared/button/LinkButton';
import MultiSelectDropdown from 'components/shared/dropdown/MultiSelectDropdown';
import classes from './ViewActions.module.scss';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { setNotifyuserList } from 'store/customer/customerViewSlice';

const ShareViewModal = ({ openModal, setOpenModal }) => {
  const [selectedUsers, setSelectedUsers] = useState([]);
  const dispatch = useDispatch();
  const appActiveUsers = useSelector((state) => state?.CustomerView?.appUsers);

  const handleCloseModal = () => {
    setSelectedUsers([]);
    setOpenModal((pre) => ({ ...pre, isShared: false }));
  };

  const handleShare = async () => {
    setOpenModal((pre) => ({ ...pre, isShared: false }));

    setSelectedUsers([]);
  };

  const onSelectUser = (value) => {
    setSelectedUsers(value);
    let usersData = value?.map((item) => {
      return { name: item?.label, email: item?.email };
    });
    dispatch(setNotifyuserList(usersData));
  };

  const content = (
    <div className={classes['content-container']}>
      <div className='d-flex align-items-center'>
        <i
          className={`icon icon__share-popup ${classes['remove-icon-wrap']}`}></i>
        <span className='title__medium title__bold mt-1 ml-1'>Share View</span>
      </div>
      <div className='text text__small pt-1'>
        Select users to share the view with. Recipients will see near real-time
        updates.
      </div>
      <div className={classes['dropdown-wrap']}>
        <div className={`d-flex text text__small`}>Users</div>
        <MultiSelectDropdown
          options={appActiveUsers}
          selected={selectedUsers}
          setSelected={(e) => onSelectUser(e)}
          hasSelectAll={false}
        />
      </div>
      <div className={`d-flex justify-content-end mt-4`}>
        <LinkButton
          className='text text__small'
          onClick={handleCloseModal}>
          Cancel
        </LinkButton>

        <Button
          variant='btn btn-gne btn-primary'
          onClick={handleShare}
          className={`text__small ms-3 ${classes['save-btn']}`}
          disabled={isEmpty(selectedUsers)}>
          Share
        </Button>
      </div>
    </div>
  );

  return (
    <GNEModal
      show={openModal}
      onHide={handleCloseModal}
      content={content}
      css='size-medium'
      backdrop='static'
    />
  );
};

export default ShareViewModal;
